"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.474 4.342a.5.5 0 1 0-.948.316l.094.283c-1.832-.867-3.452-.913-4.782-.534-1.58.45-2.698 1.481-3.254 2.316a.5.5 0 1 0 .832.554c.444-.665 1.376-1.533 2.696-1.909 1.094-.31 2.494-.295 4.16.515l-.43.143a.5.5 0 1 0 .316.948l1.5-.5a.5.5 0 0 0 .316-.632zM21 9.995a.5.5 0 0 0-1 .01c.01.984-.292 2.043-1.36 3.148a.5.5 0 0 0 .72.695c1.253-1.297 1.654-2.61 1.64-3.853"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.5 7a.5.5 0 0 1 .5.5V8h5v-.5a.5.5 0 0 1 1 0V8h1.5A1.5 1.5 0 0 1 18 9.5v9a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 5 18.5v-9A1.5 1.5 0 0 1 6.5 8H8v-.5a.5.5 0 0 1 .5-.5M17 9.5a.5.5 0 0 0-.5-.5H15v.5a.5.5 0 0 1-1 0V9H9v.5a.5.5 0 0 1-1 0V9H6.5a.5.5 0 0 0-.5.5V11h11zm-5 4a.5.5 0 0 0-.854-.354l-1 1a.5.5 0 0 0 .708.708l.146-.147V17.5a.5.5 0 0 0 1 0z"
  })]
}), 'SubscriptionFilled');
//# sourceMappingURL=index.js.map